import React, {useEffect} from 'react'
import { Row, Col } from 'reactstrap';

import GlossaryList from './_list';
import GlossaryForm from "./_form";
import { connect } from 'react-redux'
import { showLoader } from '../../components/loader/loader';
import { setApp, clearState, setLoading } from '../../redux/actions/generalActions/mainActions'
import { clearState as clearListState } from '../../redux/actions/generalActions/listActions'
import NewItem from "../../components/buttons/newItem";
import {confirmAlert} from "react-confirm-alert";
import { NO, UPDATE_GLOSSARY_LABEL, YES } from "../../components/i18n/i18n";
import { glossaryService } from "../../jwt/_services/xooka/glossaryService";

const Glossary = props => {
    const { viewMode, loading } = props.glossaryState

    useEffect( () => {
        window.localStorage.setItem('updateGlossary', '0')

        return () => {
            const val = window.localStorage.getItem('updateGlossary')

            if(val == '1')
                confirmUpdateGlossary()

            props.clearState()
            props.clearListState()

            window.localStorage.removeItem('updateGlossary')
        }
    },[] )

    const confirmUpdateGlossary = () => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside: true,
        customUI: ({onClose}) => <div className='custom-ui'>
            <h1>{UPDATE_GLOSSARY_LABEL}</h1>
            <p>{}</p>
            <button onClick={onClose}>{NO}</button>
            <button className={"btn-alert-delete"} onClick={() => {
                props.setLoading(true)

                glossaryService.saveItem()
                    .then(result => {})
                    .catch(error => console.log("Error al guardar el glosario", error))
                    .finally(() => props.setLoading(false))

                onClose();
            }}>
                {YES}
            </button>
        </div>
    });

    return(<>
        { loading && showLoader() }
        <NewItem />
        <Row>
            <Col>
                {(function(){
                    switch (viewMode){
                        case 'LIST':
                            return <GlossaryList />
                        case 'FORM':
                            return <GlossaryForm />
                        default:
                            return null
                    }
                })()}
            </Col>
        </Row>
    </>)
}

const mapStateToProps = state => ({
    glossaryState: state.mainProps
})
const mapActionsToProps = ({
    setApp,
    clearState,
    clearListState,
    setLoading,
})

export default connect(mapStateToProps, mapActionsToProps)(Glossary)